import Config from '../config'
import type { CountryType } from '../types'

// will be called from external projects only not webcommon
export function overwriteConfigVariables(assetHost: string, baseUrl: string, country: CountryType, imageServerUrl: string, messagingAppKey?: string) {
    Config.assetHost = assetHost;
    Config.baseUrl = baseUrl;
    Config.country = country;
    Config.imageServerUrl = imageServerUrl;
    Config.messagingAppKey = !!messagingAppKey ? messagingAppKey : Config.messagingAppKey;
}

export function getAsset(assetLocation: string): string {
    if (Config.assetHost) {
        return `${Config.assetHost}/assets/${assetLocation}`;
    }
    return Config.baseUrl + `/src/assets/${assetLocation}`;
}

export function getCountry(): CountryType {
    if (Config.country) {
        return Config.country;
    }
    return 'au';
}

export const COUNTRY_CODE = Config.country || 'au';

export function getImageServerUrl(): string {
    if (Config.imageServerUrl) {
        return Config.imageServerUrl;
    }
    return '';
}

export function getCurrencySymbol(): string {
    if (!!Config.currencySymbol) {
        return Config.currencySymbol;
    }
    return '$';
}

export function getMessagingKey(): string {
    if (!!Config.messagingAppKey) {
        return Config.messagingAppKey;
    }
    return '';
}
